var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin__home"},[_c('Header'),_c('div',{staticClass:"admin__home--left-div"},[_c('Sidebar',{attrs:{"item":_vm.item}})],1),_c('div',{staticClass:"admin__home--right-div"},[_c('div',[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }